skrilla.controller('permissionsModalCtrl', function ($scope, searchService, cacheService, modalService, adminService) {
    $scope.mode = "edit";
    $scope.permissions = [
        {name : "adminViewUser", text: "View Users"}, {name : "adminEditUser", text: "Edit Users"},
        {name : "adminViewContest", text: "View Contests"}, {name : "adminEditContest", text: "Edit Contests"},
        {name : "adminCreateContest", text: "Create Contests"}, {name : "adminResultContest", text: "Result Contests"},
        {name : "adminCancelContest", text: "Cancel Contests"}, {name : "adminPublishContest", text: "Publish Contests"},
        {name : "adminViewBet", text: "View Bets"}, {name : "adminEditBet", text: "Edit Bets"},
        {name : "adminViewBettingMarkets", text: "View Betting Markets"}, {name : "adminEditBettingMarkets", text: "Edit Betting Markets"},
        {name : "adminManageProviders", text: "Manage connections to Odds providers"},
        {name : "adminViewData", text: "View Data"}, {name : "adminEditData", text: "Edit Data"},
        {name : "adminViewFinancials", text: "View Financials"}, {name : "adminEditFinancials", text: "Edit Financials"},
        {name : "adminViewAccounts", text: "View Accounts"}, {name : "adminEditAccounts", text: "Edit Accounts"},
        {name : "adminViewAdmin", text: "View Admins"}, {name : "adminEditAdmin", text: "Edit Admins"},
        {name : "adminViewManualTransaction", text: "View Manual Transactions"}, {name : "adminEditManualTransaction", text: "Edit Manual Transactions"},
        {name : "adminViewWithdrawal", text: "View Withdrawals"}, {name : "adminEditWithdrawal", text: "Edit Withdrawals"},
        {name : "adminViewMarketPlace", text: "View Market Place"}, {name : "adminEditMarketPlace", text: "Edit Market Place"},
        {name : "adminViewLimit", text: "View Limits"}, {name : "adminEditLimit", text: "Edit Limits"},
        {name : "adminViewPromotion", text: "View Promotions"}, {name : "adminEditPromotion", text: "Edit Promotions"},
        {name : "adminViewAffiliate", text: "View Affiliates"}, {name : "adminEditAffiliate", text: "Edit Affiliates"},
        {name : "adminViewSkrillaJobs", text: "View Skrilla Jobs"}, {name : "adminEditSkrillaJobs", text: "Edit Skrilla Jobs"},
        {name : "adminEditContestState", text: "Edit Contest State"}, {name : "adminEditUserMigration", text: "Edit User Migration"},
        {name : "adminViewQuartzJobs", text: "View Quartz Jobs"},
        {name : "adminEditQuartzJobs", text: "Edit Quartz Jobs"},
        {name : "adminViewConfig", text: "View Config"}, {name : "adminEditConfig", text: "Edit Config"},
        {name : "adminViewPPI", text: "View PPI"},
        {name : "adminEditBettingMarketCategories", text: "Edit Betting Market Categories"},
        {name : "adminReOpenExcludedUser", text: "Re Open Excluded Users"},
    ];
    var role = cacheService.getObject("role");
    if(Object.keys(role).length === 0 && role.constructor === Object){
        $scope.mode = "create";
    }
    else{
        $scope.role = {name: role.name};
        console.log(role);
        role.permissions.forEach(function(rolePermission){
            $scope.permissions.forEach(function(permission){
               if(permission.name === rolePermission){
                   permission.selected = true;
               }
            });
        });
    }

    $scope.selectAll = function(){
        $scope.selected = !$scope.selected;
        $scope.permissions.forEach(function(role){
            role.selected = $scope.selected;
        });
    }

    $scope.cancel = function(){modalService.dismissAll();}

    $scope.savePermissions = function(){
        var permissionsArr = [];
        $scope.permissions.forEach(function(permission){
            if(permission.selected === true) permissionsArr.push(permission.name);
        });
        if($scope.mode === "create") {
            searchService.post('roles', {
                name: $scope.role.name,
                permissions: permissionsArr
            }, "Role permissions Successfully updated!").then(function successCallback(response) {
                adminService.getAdmin(true);
                modalService.dismissAll();
            });
        }
        else{
            role.permissions = permissionsArr;
            role.name = $scope.role.name;
            console.log(role);
            searchService.put("roles/" + role.id, role.permissions, "Role Successfully updated!").then(function(response){
                adminService.getAdmin(true);
                modalService.dismissAll();
            });
        }
    }

});

